<template>
  <div class="ai-platform-page hero-style-home">
    <div class="ai-hero-banner">
      <img
        src="@/assets/jiejue/custom/private-cloud-hero-banner.svg"
        alt=""
        style="width: 100%"
        @load="loaded = true"
        :class="{ show: loaded }"
        class="top_img"
      />
      <div class="ai-hero-title">{{ solutionHeroTitle }}</div>
    </div>

    <nav class="product-tabs-bar">
      <a
        class="product-tab"
        :class="{ active: activeTab === 'background' }"
        href="#background"
        @click.prevent="scrollTo('background')"
        >需求背景</a
      >
      <a
        class="product-tab"
        :class="{ active: activeTab === 'challenges' }"
        href="#challenges"
        @click.prevent="scrollTo('challenges')"
        >业务挑战</a
      >
      <a
        class="product-tab"
        :class="{ active: activeTab === 'scenarios' }"
        href="#scenarios"
        @click.prevent="scrollTo('scenarios')"
        >场景应用</a
      >
      <a
        v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM"
        class="product-tab"
        :class="{ active: activeTab === 'architecture' }"
        href="#architecture"
        @click.prevent="scrollTo('architecture')"
        >部署示意图</a
      >
      <a
        class="product-tab"
        :class="{ active: activeTab === 'advantages' }"
        href="#advantages"
        @click.prevent="scrollTo('advantages')"
        >方案优势</a
      >
      <a
        class="product-tab"
        :class="{ active: activeTab === 'cases' }"
        href="#cases"
        @click.prevent="scrollTo('cases')"
        >典型案例</a
      >
    </nav>

    <div class="product-body">
    <section
      id="background"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': backgroundVisible }"
    >
      <div class="section-title">需求背景</div>
      <div class="section-content">
        <div class="background-card">
          <p class="case-text case-text-full">
            {{ backgroundIntroLead }}是基于自研的云计算架构构建的集中化安全能力供给平台，采用自主研发的 VSW 智能编排能力，对流量型安全网关如防火墙、Web 应用防火墙（WAF）、入侵检测 / 防御等实现智能的编排，对于非流量型安全网关和客户端型网关支持按需弹性调度与快速部署；同时基于统一云安全管理平台实现统一的安全策略管理、风险实时监测与告警功能，能精准识别云环境中的安全威胁与合规隐患，大幅简化云安全运维流程，降低安全建设成本，为政企单位的云业务提供全生命周期、可扩展的安全保障。
          </p>
        </div>
      </div>
    </section>

    <section
      id="challenges"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': challengesVisible }"
      style="background-color: #fff"
    >
      <div class="section-title">业务挑战</div>
      <div class="section-content">
      <div class="grid-2">
        <div class="card">
          <img
            class="card-icon"
            src="@/assets/products/CloudSecurityResourcePool/ta.png"
            alt="icon"
          />
          <div class="card-text">
            <div class="card-title">基础设施与虚拟化安全风险</div>
            <div class="card-desc">
              私有云依赖的物理服务器、存储设备若存在硬件故障或配置漏洞，可能导致服务中断；虚拟化层（如 KVM、VMware）的漏洞可能引发虚拟机逃逸、镜像投毒等问题，破坏租户（内部部门）间的隔离边界，威胁核心业务系统安全。
            </div>
          </div>
        </div>
        <div class="card">
          <img
            class="card-icon"
            src="@/assets/products/CloudSecurityResourcePool/tc.png"
            alt="icon"
          />
          <div class="card-text">
            <div class="card-title">身份认证与访问控制漏洞</div>
            <div class="card-desc">
              内部用户、管理员权限划分模糊，易出现超权限操作、离职人员权限未及时回收等情况；针对动态扩容的云资源（如临时计算节点），静态权限配置难以适配，可能形成权限管控盲区，为内部越权访问或恶意操作提供可乘之机。
            </div>
          </div>
        </div>
        <div class="card">
          <img
            class="card-icon"
            src="@/assets/products/CloudSecurityResourcePool/tb.png"
            alt="icon"
          />
          <div class="card-text">
            <div class="card-title">数据全生命周期管控不足</div>
            <div class="card-desc">
              数据在私有云内的存储、传输、备份环节可能存在加密覆盖不全的问题，敏感数据易被非法窃取；多副本存储的管理不当的问题，以及资源释放后的数据残留问题，可能导致数据泄露；同时，内部人员误操作或恶意拷贝，也会加剧数据安全风险。
            </div>
          </div>
        </div>
        <div class="card">
          <img
            class="card-icon"
            src="@/assets/products/CloudSecurityResourcePool/td.png"
            alt="icon"
          />
          <div class="card-text">
            <div class="card-title">安全监控与应急响应滞后</div>
            <div class="card-desc">
              私有云的日志分散在不同节点和设备中，难以实现统一采集与关联分析，易出现威胁检测盲区；面对勒索软件、内部攻击等高级威胁，传统安全工具的检测能力有限，且应急响应流程缺乏实战化打磨，可能导致安全事件处置延迟，扩大损失范围。
            </div>
          </div>
        </div>
      </div>
      </div>
    </section>

    <section
      id="scenarios"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': scenariosVisible }"
    >
      <div class="section-title">场景应用</div>
      <div class="section-content">
      <div class="scenarios">
        <div class="scenario-text">
          <p class="scenario-desc">
            随着云计算的快速发展，传统的安全防护手段逐渐无法满足用户在云计算环境下的安全需求。在云计算多租户场景中，租户通常会根据自身业务需求和安全合规要求进行顶层安全设计。当前云平台能提供的安全措施屈指可数，租户顶层安全设计难以落地，业务系统安全难以保障。中国云信任报告显示：安全成为租户业务上云的最大顾虑。安全资源池专注于为云租户提供丰富的安全功能，保障云租户业务系统在云上安全可靠地运行。
          </p>
        </div>
        <img
          src="@/assets/products/CloudSecurityResourcePool/right.png"
          alt=""
          style="width: 50%; border-radius: 4px"
          class="mobile-hidden-img"
        />
      </div>
      </div>
    </section>

    <section
      v-if="SHOW_SOLUTION_DEPLOY_DIAGRAM"
      id="architecture"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': architectureVisible }"
      style="background-color: #fff"
    >
      <div class="section-title">部署示意图</div>
      <div class="section-content">
      <img
        src="@/assets/solutions/deploy/resource-pool.svg"
        alt="部署示意图"
        class="architecture-image"
      />
      </div>
    </section>

    <section
      id="advantages"
      class="product-section section-row advantages ai-platform-block"
      :class="{ 'animate-in': advantagesVisible }"
    >
      <div class="section-title">方案优势</div>
      <div class="section-content">
      <div class="grid-5">
        <div class="adv-card">
          <img src="@/assets/jiejue/1.svg" alt="" class="adv-badge" />
          <div class="adv-title">统一管理</div>
          <div class="adv-desc">
            提供资源池内安全产品的统一登录、统一配置、统一引流，为云服务方统一管理提供了支撑平台
          </div>
        </div>
        <div class="adv-card">
          <img src="@/assets/jiejue/2.svg" alt="" class="adv-badge" />
          <div class="adv-title">统一运维</div>
          <div class="adv-desc">
            提供对平台自身各组件，以及云安全资源池内的宿主机、安全网元等全方位监控能力。包括对组件的健康度监控、配置信息监控、性能负载监控等
          </div>
        </div>
        <div class="adv-card">
          <img src="@/assets/jiejue/3.svg" alt="" class="adv-badge" />
          <div class="adv-title">按需扩展</div>
          <div class="adv-desc">
            云安全资源池可根据云租户的增加、业务的增加，按需扩展安全能力
          </div>
        </div>
        <div class="adv-card">
          <img src="@/assets/jiejue/4.svg" alt="" class="adv-badge" />
          <div class="adv-title">满足安全合规要求</div>
          <div class="adv-desc">
            支持与云平台深度集成，便于业务扩展与持续演进。
          </div>
        </div>
        <div class="adv-card">
          <img src="@/assets/jiejue/5.svg" alt="" class="adv-badge" />
          <div class="adv-title">安全可管可控</div>
          <div class="adv-desc">
            云平台内所有资产状态、威胁情况、行为情况等，100%可知可见。
          </div>
        </div>
      </div>
      </div>
    </section>

    <section
      id="cases"
      class="product-section section-row ai-platform-block"
      :class="{ 'animate-in': casesVisible }"
    >
      <div class="section-title">典型案例</div>
      <div class="section-content section-content-cases">
        <div class="case-content case-content-blink">
          <div class="case-section">
            <h3 class="case-subtitle">需求背景</h3>
            <p class="case-text">
              某省电信运营的云平台是国内领先的混合云平台，兼具规模与技术优势，承载着大量政企租户的业务系统。随着公安部《公安机关网络空间安全监督检查办法（征求意见稿）》的发布，等级保护要求进一步细化，明确要求三级以上网络运营者每年需接受一次现场检查，上云业务系统需全面符合等保2.0要求。当前，该电信云平台面临的核心问题的是：租户安全需求差异化大，难以提供针对性的安全服务；传统安全设备分散部署，资源利用率低，运维成本高；各安全组件独立运行，形成“安全孤岛”，无法实现协同防御；需快速响应租户合规需求，助力租户顺利通过等保测评。为此，该省电信联合安全厂商，引入云安全资源池解决方案，以“安全即服务”模式，为租户提供全方位安全保障。
            </p>
          </div>
          <div class="case-section">
            <h3 class="case-subtitle">用户痛点</h3>
            <ul class="case-list">
              <li>1. 租户安全需求差异化：不同行业、不同规模的租户，对安全防护的需求不同，部分租户需满足等保三级要求，部分租户仅需基础安全防护，难以实现标准化交付；</li>
              <li>2. 安全资源调度效率低：传统安全资源分散部署，无法根据租户流量峰值、安全需求弹性扩容，易出现资源闲置或不足的情况；</li>
              <li>3. 安全组件协同性差：防火墙、WAF、审计等安全组件独立运行，数据无法共享、策略无法联动，难以形成纵深防御体系；</li>
              <li>4. 合规支撑能力不足：租户需独立完成等保备案测评，现有安全资源无法快速适配等保2.0要求，合规整改周期长、成本高。</li>
            </ul>
          </div>
          <div class="case-section">
            <h3 class="case-subtitle">解决方案</h3>
            <ul class="case-list">
              <li>1. 构建集约化安全资源池：将云防火墙、云WAF、EDR主机安全、数据库审计、日志审计、堡垒机等核心安全组件，集约化部署于云平台专属网络区域（VPC），形成统一的云安全资源池，实现安全能力的集中供给、统一调度和弹性扩展。</li>
              <li>2. 提供差异化安全服务：根据租户需求，将安全资源池的能力封装为不同等级的服务套餐，适配等保二级、三级及基础防护需求，租户可按需订阅、灵活扩容，实现“安全即服务”，既满足差异化需求，又避免资源浪费。</li>
              <li>3. 打破安全孤岛，实现协同防御：搭建安全协同管理平台，实现各安全组件的数据共享、策略联动和应急处置，例如WAF检测到Web攻击后，自动同步至云防火墙，拦截攻击IP，形成纵深防御体系，缩短安全响应时间。</li>
              <li>4. 强化合规支撑能力：将等保2.0合规要求嵌入安全资源池设计，为租户提供等保合规所需的安全能力，租户需进行等保测评时，可快捷分配对应安全资源，快速完成合规整改；同时提供合规审计报表，助力租户顺利通过等保备案测评。</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    </div>

    
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import { useRoute } from 'vue-router'
import { SHOW_SOLUTION_DEPLOY_DIAGRAM } from '@/data/solutionUi.js'
import resourcePoolBanner from '@/assets/jiejue/custom/private-cloud-hero-banner.svg'

const route = useRoute()

/** 「解决方案（新）」入口 /solutions/private-cloud-security 与本页主路径共用组件，文案按路由区分 */
const isPrivateCloudSecurityPage = computed(() => route.path === '/solutions/private-cloud-security')

const solutionHeroTitle = computed(() =>
  isPrivateCloudSecurityPage.value ? '私有云安全解决方案' : '云安全资源池解决方案'
)

const backgroundIntroLead = computed(() => (isPrivateCloudSecurityPage.value ? '私有云' : '云安全资源池'))

const loaded = ref(false)

defineOptions({
  banner: resourcePoolBanner
})

const isScrollingProgrammatically = ref(false)
const isUserScrolling = ref(false)
const userScrollTimeout = ref(null)
const animationObserver = ref(null)
const navObserver = ref(null)
const navTimeout = ref(null)
const handleUserScroll = ref(null)
const activeTab = ref('background')
const backgroundVisible = ref(false)
const challengesVisible = ref(false)
const scenariosVisible = ref(false)
const architectureVisible = ref(false)
const advantagesVisible = ref(false)
const casesVisible = ref(false)

const scrollTo = (id) => {
  const el = document.getElementById(id)
  if (!el) return
  activeTab.value = id
  history.replaceState(null, '', `#${id}`)
  isScrollingProgrammatically.value = true
  if (el.scrollIntoView) {
    el.scrollIntoView({ behavior: 'smooth', block: 'start' })
  } else {
    const stickyOffset = 120
    const y = el.getBoundingClientRect().top + window.scrollY - stickyOffset
    window.scrollTo({ top: y, behavior: 'smooth' })
  }
  setTimeout(() => {
    isScrollingProgrammatically.value = false
  }, 1000)
}

onMounted(() => {
  activeTab.value = 'background'

  handleUserScroll.value = () => {
    if (isScrollingProgrammatically.value) return
    isUserScrolling.value = true
    if (userScrollTimeout.value) clearTimeout(userScrollTimeout.value)
    userScrollTimeout.value = setTimeout(() => {
      isUserScrolling.value = false
    }, 150)
  }

  window.addEventListener('scroll', handleUserScroll.value, { passive: true })

  animationObserver.value = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const id = entry.target.id
          if (id === 'background') backgroundVisible.value = true
          else if (id === 'challenges') challengesVisible.value = true
          else if (id === 'scenarios') scenariosVisible.value = true
          else if (id === 'architecture') architectureVisible.value = true
          else if (id === 'advantages') advantagesVisible.value = true
          else if (id === 'cases') casesVisible.value = true
        }
      })
    },
    { threshold: 0.1, rootMargin: '0px 0px -50px 0px' }
  )

  navObserver.value = new IntersectionObserver(
    (entries) => {
      if (isScrollingProgrammatically.value) return
      if (!isUserScrolling.value) return
      const visibleEntries = entries.filter((entry) => entry.isIntersecting)
      if (visibleEntries.length > 0) {
        if (navTimeout.value) clearTimeout(navTimeout.value)
        navTimeout.value = setTimeout(() => {
          if (isScrollingProgrammatically.value) return
          let maxEntry = visibleEntries[0]
          for (const entry of visibleEntries) {
            if (entry.intersectionRatio > maxEntry.intersectionRatio) {
              maxEntry = entry
            }
          }
          const id = maxEntry.target.id
          if (id && activeTab.value !== id) {
            activeTab.value = id
            history.replaceState(null, '', `#${id}`)
          }
        }, 50)
      }
    },
    {
      root: null,
      threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1],
      rootMargin: '-80px 0px -50% 0px'
    }
  )

  const ids = ['background', 'challenges', 'scenarios', 'architecture', 'advantages', 'cases']
  ids.forEach((id) => {
    const el = document.getElementById(id)
    if (el) {
      animationObserver.value.observe(el)
      navObserver.value.observe(el)
    }
  })
})

onBeforeUnmount(() => {
  if (animationObserver.value) animationObserver.value.disconnect()
  if (navObserver.value) navObserver.value.disconnect()
  if (navTimeout.value) clearTimeout(navTimeout.value)
  if (userScrollTimeout.value) clearTimeout(userScrollTimeout.value)
  if (handleUserScroll.value) {
    window.removeEventListener('scroll', handleUserScroll.value)
  }
})
</script>

<style scoped>
@import '../../assets/css/solution-page.css';

.ai-hero-banner {
  position: relative;
  overflow: hidden;
}

.ai-hero-title {
  position: absolute;
  top: 50%;
  left: 12%;
  transform: translateY(-50%);
  font-size: 48px;
  color: var(--color-text);
  font-weight: 600;
  letter-spacing: 0.01em;
  text-shadow: 0 8px 24px rgba(255, 255, 255, 0.6);
  z-index: 2;
  pointer-events: none;
  white-space: nowrap;
}

.ai-platform-page {
  font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
  color: var(--color-text);
}

.ai-platform-block {
  opacity: 0;
  transform: translateY(30px);
  transition: opacity 0.6s ease, transform 0.6s ease;
}

.ai-platform-block.animate-in {
  opacity: 1;
  transform: translateY(0);
}

.background-card {
  width: 100%;
  box-sizing: border-box;
  background: #fff;
  border-radius: 8px;
  padding: 36px 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid #e8e8e8;
  transition: box-shadow 0.3s ease;
}

.background-card:hover {
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
}

.case-content {
  max-width: 100%;
  margin: 0 auto;
  text-align: left;
}

.section-content-cases {
  text-align: left;
}

.case-content-blink {
  padding: 24px;
  border-radius: 8px;
  animation: case-blink 2.5s ease-in-out infinite;
}

@keyframes case-blink {
  0%, 100% { opacity: 1; box-shadow: 0 0 0 rgba(6, 85, 159, 0); }
  50% { opacity: 0.88; box-shadow: 0 0 28px rgba(6, 85, 159, 0.25); }
}

.case-section + .case-section {
  margin-top: 32px;
}

.case-subtitle {
  font-size: 20px;
  font-weight: 600;
  color: #06559f;
  margin-bottom: 12px;
}

.case-text {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
}

.case-text-full {
  font-size: 16px;
  line-height: 1.9;
  text-align: left;
}

.case-list {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  padding-left: 0;
  list-style: none;
}

@media (max-width: 1200px) {
  .mobile-hidden-img {
    display: none;
  }
}

.grid-2 {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 20px;
}
.grid-4 {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
}
.grid-5 {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 20px;
}

.card {
  display: flex;
  align-items: flex-start;
  gap: 17px;
  background: #f5f7fa;
  border-radius: 6px;
  padding: 30px 30px;
  min-height: 173px;
  box-sizing: border-box;
}

.card-icon {
  flex-shrink: 0;
}
.card-text {
  display: flex;
  flex-direction: column;
  text-align: start;
}
.card-title {
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: 600;
  line-height: normal;
  letter-spacing: 0em;
  color: #000;
  line-height: 40px;
  margin-bottom: 8px;
}
.card-desc {
  font-size: 14px;
  line-height: 1.7;
  color: #666;
}

.scenarios {
  display: flex;
  align-items: stretch;
  position: relative;
  max-width: 1200px;
  margin: 0 auto;
}

.scenario-text {
  background: #fff;
  border-radius: 4px;
  padding: 40px;
  box-sizing: border-box;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  overflow: hidden;
  text-align: start;
}

.scenario-desc {
  font-size: 16px;
  line-height: 1.8;
  color: #666;
  margin: 0;
}

.scenario-img {
  width: 50%;
  border-radius: 4px;
  object-fit: cover;
}

.block-img {
  width: 100%;
  max-width: 1200px;
  display: block;
  margin: 0 auto;
}

@media (max-width: 1200px) {
  .mobile-hidden-img {
    display: none;
  }
  .scenario-text {
    border-radius: 4px;
    width: 100%;
  }
}

#advantages {
  background: linear-gradient(180deg, #f5f7fa 0%, #e0ecff 100%);
  max-width: unset;
  padding: 60px 20px 90px 20px;
}
.advantages .grid-4,
.advantages .grid-5 {
  align-items: stretch;
  gap: 20px;
  max-width: none;
  margin: 0;
}
.adv-card {
  min-height: 240px;
  position: relative;
  background: #fff;
  border-radius: 4px;
  padding: 29px;
  padding-top: 70px;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  text-align: start;
}
.adv-badge {
  display: block !important;
  position: absolute;
  top: 33px;
  left: 29px;
  width: 24px;
  height: 24px;
  border-radius: 4px;
  object-fit: contain;
}
.adv-title {
  font-size: 18px;
  font-family: PingFang SC;
  color: #333;
  margin-bottom: 10px;
  font-weight: 600;
}
.adv-desc {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

#scenarios {
  max-width: unset;
  background: #f5f7fa;
  padding: 60px 20px 90px 20px;
}

@media (max-width: 1200px) {
  .grid-2 {
    grid-template-columns: 1fr;
  }
  .grid-4 {
    grid-template-columns: repeat(2, 1fr);
  }
  .grid-5 {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 768px) {
  .product-body {
    padding: 0 16px 40px;
  }
  .grid-2 {
    grid-template-columns: 1fr;
  }
  .grid-4,
  .grid-5 {
    grid-template-columns: 1fr;
  }
  .adv-card {
    min-height: auto;
  }
  .scenario-text {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    width: 100%;
    padding: 40px 30px;
    box-sizing: border-box;
  }
  .scenarios {
    flex-direction: column;
  }
}

@media (max-width: 576px) {
  .product-tabs-bar {
    gap: 20px;
  }
}
</style>
